














import {
  DynamicDocumentItem,
  DynamicDocumentItemCustomType,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  MechanicInstallation
} from "@/types";
import Vue, { PropType, VueConstructor } from "vue";

import {
  GenericSerialNumber,
  PanelAmount,
  PanelType,
  PanelLocation,
  PanelOrientation,
  PanelGrid,
  PanelGridSize,
  InverterType,
  InverterSerialNumbers,
  InverterSerialNumberGrid,
  MeterAssociation,
  MeterSerialNumber,
  MeterSerialNumbersEnphaseGateway,
  MeterSerialNumbersEnphaseRelay,
  LayoutPlan,
  InverterConfiguration,
  NumberOfBus
} from "./custom/index";

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    moduleData: Object as PropType<InstallationModuleData>,
    module: Object as PropType<InstallationModule>,
    installation: Object as PropType<MechanicInstallation>,
    isActive: Boolean
  },

  computed: {
    renderer(): VueConstructor | undefined {
      const type = this.item.field as DynamicDocumentItemCustomType;

      switch (type) {
        case "panelAmount":
          return PanelAmount;
        case "panelType":
          return PanelType;
        case "panelLocation":
          return PanelLocation;
        case "panelOrientation":
          return PanelOrientation;
        case "panelGridSize":
          return PanelGridSize;
        case "panelGrid":
          return PanelGrid;
        case "inverterType":
          return InverterType;
        case "inverterSerialNumbers":
          return InverterSerialNumbers;
        case "inverterSerialNumberGrid":
          return InverterSerialNumberGrid;
        case "meterAssociation":
          return MeterAssociation;
        case "meterSerialNumber":
          return MeterSerialNumber;
        case "meterSerialNumbersEnphaseGateway":
          return MeterSerialNumbersEnphaseGateway;
        case "meterSerialNumbersEnphaseRelay":
          return MeterSerialNumbersEnphaseRelay;
        case "modemSerialNumber":
        case "dataloggerSerialNumber":
        case "dataloggerCcSerialNumber":
        case "communicationModuleSerialNumber":
        case "batterySerialNumber":
        case "kwhMeterSerialNumber":
          return GenericSerialNumber;
        case "layoutPlan":
          return LayoutPlan;
        case "inverterConfiguration":
          return InverterConfiguration;
        case "numberOfBus":
          return NumberOfBus;
        default:
          return undefined;
      }
    }
  }
});
